document.addEventListener('DOMContentLoaded', function() {

  const input = document.getElementById('PredictiveSearchInput');
  const results = document.getElementById('predictive-search-results');

  if (!input || !results) return;

  let timeout;

  input.addEventListener('input', function() {

    clearTimeout(timeout);

    const query = this.value.trim();

    if (query.length < 2) {
      results.style.display = 'none';
      results.innerHTML = '';
      return;
    }

    timeout = setTimeout(function() {

      fetch(
        '/search/suggest.json?q=' +
        encodeURIComponent(query) +
        '&resources[type]=product&resources[limit]=6'
      )
      .then(response => response.json())
      .then(data => {

        const products = data.resources.results.products;

        if (!products.length) {
          results.innerHTML =
            '<div style="padding:10px">No products found</div>';
          results.style.display = 'block';
          return;
        }

        let html = '';

        products.forEach(function(product) {

          html += `
            <a class="predictive-item" href="${product.url}">
              ${product.featured_image ?
                `<img src="${product.featured_image.url}" alt="">`
                : ''
              }
              <div>
                <div>${product.title}</div>
                <small>${product.price}</small>
              </div>
            </a>
          `;
        });

        results.innerHTML = html;
        results.style.display = 'block';
      });

    }, 250);
  });

  document.addEventListener('click', function(e) {
    if (!e.target.closest('.search-bar')) {
      results.style.display = 'none';
    }
  });

});